import { Question } from '../../question.class';


const type = 'text';

let QuestionOnComposeInit = Question.prototype.onComposeInit;
Question.prototype.onComposeInit = function(...args) {
  if (args[0] === type) {
    // no max_checked_option_cnt, no sub question, no options allowed.
    (<Question>this).max_checked_option_cnt = null;
    (<Question>this)
      .getDecendantQuestions()
      .forEach(q => q.survey.deleteQuestions({ id: q.id }));
    (<Question>this).deleteOptions(undefined);
    (<Question>this).addOption({ type: 'text', text: '' });
    QuestionOnComposeInit.apply(this, args);
  } else {
    QuestionOnComposeInit.apply(this, args);
  }
};
let QuestionOnComposeDestroy = Question.prototype.onComposeDestroy;
Question.prototype.onComposeDestroy = function(...args) {
  if (args[0] === type) {
    (<Question>this).deleteOptions(undefined);
    QuestionOnComposeDestroy.apply(this, args);
  } else {
    QuestionOnComposeDestroy.apply(this, args);
  }
};

console.log("question type text is added");